class CommonHelper {

    public static Extract = <T extends object>(values: T, keys: string[]): T => {
        let output = {};
        for (let i = 0; i < keys.length; i++) {
            let key: string = keys[i];
            (output as any)[key] = (values as any)[key];
        }
        return output as any;
    }

    public static Delay = async (time: number): Promise<void> => {
        await new Promise((resolve) => setTimeout(resolve, Math.floor(time * 1000)));
        return Promise.resolve();
    }

    public static AddSeconds = (date: Date, seconds: number): Date => {
        date.setSeconds(date.getSeconds() + seconds);
        return date;
    }

    public static AddMinutes = (date: Date, minutes: number): Date => {
        date.setMinutes(date.getMinutes() + minutes);
        return date;
    }

    public static AddHours = (date: Date, hours: number): Date => {
        date.setHours(date.getHours() + hours);
        return date;
    }

    public static AddDays = (date: Date, days: number): Date => {
        date.setDate(date.getDate() + days);
        return date;
    }

    public static AddMonths = (date: Date, months: number): Date => {
        date.setMonth(date.getMonth() + months);
        return date;
    }

    public static AddYears = (date: Date, years: number): Date => {
        date.setFullYear(date.getFullYear() + years);
        return date;
    }


    public static Paging = (current: number, max: number): { current: number, prev: number, next: number, items: number[], hasHidden: boolean } => {

        let prev: number = current === 1 ? -1 : current - 1,
            next: number = current === max ? -1 : current + 1,
            items: number[] = [1],
            hasHidden: boolean = false;

        if (current === 1 && max === 1) return { current, prev, next, items, hasHidden };
        if (current > 4) {
            items.push(-1);
            hasHidden = true;
        };

        let r = 2, r1 = current - r, r2 = current + r;

        for (let i = r1 > 2 ? r1 : 2; i <= Math.min(max, r2); i++) items.push(i);

        if (r2 + 1 < max) {
            items.push(-1);
            hasHidden = true;
        };
        if (r2 < max) items.push(max);

        return { current, prev, next, items, hasHidden };
    }

}

export default CommonHelper;